import BeatLoader from 'components/animations/Loaders/BeatLoader';
import { ModalProps } from 'components/containers/Modal/Modal';
import BaseLandaFinancingModal from 'pages/lend/components/BaseComponents/BaseLandaFinancingModal';
import LandaFinancingActivityRow from 'pages/lend/components/LandaFinancingActivity/components/LandaFinancingActivityRow';
import useFinancingActivityFetcher from 'pages/lend/components/LandaFinancingActivity/hooks/useFinancingActivityFetcher';
import React from 'react';
import classes from './index.module.scss';
import InfiniteScrollContainer from 'components/containers/InfiniteScrollContainer';

const LandaFinancingActivityModal = (props: ModalProps) => {
  const { loading, data, fetchNextPage, hasMore } =
    useFinancingActivityFetcher();

  return (
    <BaseLandaFinancingModal
      className={classes.container}
      title={'Landa Financing Activity'}
      {...props}
    >
      <InfiniteScrollContainer
        outerDivClassName={classes.scrollOuterDiv}
        className={classes.scroll}
        next={fetchNextPage}
        dataLength={data?.length}
        key={'lend-activity-modal'}
        hasMore={hasMore}
        loader={loading && <BeatLoader className={classes.loadMore} />}
        height={'100%'}
      >
        {data?.map((item) => (
          <LandaFinancingActivityRow
            item={item}
            key={item.id}
            className={classes.row}
          />
        ))}
      </InfiniteScrollContainer>
    </BaseLandaFinancingModal>
  );
};

export default LandaFinancingActivityModal;
